var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRadiouncheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.38 0.620117C3.321 0.620117 0 3.94112 0 8.00012C0 12.0591 3.321 15.3801 7.38 15.3801C11.439 15.3801 14.76 12.0591 14.76 8.00012C14.76 3.94112 11.439 0.620117 7.38 0.620117ZM7.38 13.9041C4.1328 13.9041 1.476 11.2473 1.476 8.00012C1.476 4.75292 4.1328 2.09612 7.38 2.09612C10.6272 2.09612 13.284 4.75292 13.284 8.00012C13.284 11.2473 10.6272 13.9041 7.38 13.9041Z",
    fill: "#686B6F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiouncheck);
export default __webpack_public_path__ + "static/media/radiouncheck.bab8ae1de7a62fe542232782888d1065.svg";
export { ForwardRef as ReactComponent };